import { z } from 'zod';
import { recaptchaTokenSchema } from './shared.js';
/** Unified candidate application (general `/apply` and the embedded job-page form). */
export const APPLICATION_TRACKS = ['permanent', 'b2b', 'both'];
export const NOTICE_PERIODS = ['immediately', '2weeks', '1month', '2months', '3months'];
const optionalText = (max) => z.string().trim().max(max).optional().or(z.literal(''));
export const applicationSchema = z
    .object({
    /** Engagement fork: asked on `/apply`, resolved from the job's tag on a job page. */
    track: z.enum(APPLICATION_TRACKS, { errorMap: () => ({ message: 'chooseOption' }) }),
    fullName: z.string().trim().min(1).max(255),
    email: z.string().trim().email(),
    phone: z.string().trim().min(5).max(40),
    linkedin: z.string().trim().url().optional().or(z.literal('')),
    role: z.string().trim().min(1).max(200),
    city: z.string().trim().min(1).max(120),
    /** Job id when applying through a job page (informational; Manatal gets it via the URL). */
    jobId: optionalText(40),
    // Permanent / both
    salary: optionalText(60),
    notice: z.enum(NOTICE_PERIODS).optional(),
    relocate: z.boolean().default(false),
    // B2B / both
    rate: optionalText(60),
    availability: optionalText(120),
    applyAs: z.enum(['solo', 'team']).default('solo'),
    teamSize: optionalText(200),
    /** GDPR consent — never pre-ticked. */
    consent: z.boolean().refine((v) => v, { message: 'consentRequired' }),
    /** Function sets this from the parsed multipart file. */
    hasResumeFile: z.boolean().default(false),
    recaptchaToken: recaptchaTokenSchema,
})
    .refine((v) => v.hasResumeFile, { message: 'resumeRequired', path: ['hasResumeFile'] })
    .refine((v) => v.applyAs !== 'team' || !!v.teamSize, {
    message: 'required',
    path: ['teamSize'],
});
//# sourceMappingURL=application.js.map